import { type } from '@/utils/type'

//////////////////////////////////////////////////////////////////
// MARQUE
/////////////////////////////////////////////////////////////////
export const CATALOGUE_MARQUE_REQUEST =  type('CATALOGUE_MARQUE_REQUEST')
export const CATALOGUE_MARQUE_ENSURE =  type('CATALOGUE_MARQUE_ENSURE')

//////////////////////////////////////////////////////////////////
// REFERENCE
/////////////////////////////////////////////////////////////////
export const CATALOGUE_REFERENCE_REQUEST =  type('CATALOGUE_REFERENCE_REQUEST')
export const CATALOGUE_REFERENCE_ENSURE =  type('CATALOGUE_REFERENCE_ENSURE')

//////////////////////////////////////////////////////////////////
// TREE
/////////////////////////////////////////////////////////////////
export const CATALOGUE_TREE_REQUEST =  type('CATALOGUE_TREE_REQUEST')
export const CATALOGUE_TREE_ENSURE =  type('CATALOGUE_TREE_ENSURE')

//////////////////////////////////////////////////////////////////
// META
/////////////////////////////////////////////////////////////////
export const CATALOGUE_META_REQUEST =  type('CATALOGUE_META_REQUEST')
export const CATALOGUE_META_ENSURE =  type('CATALOGUE_META_ENSURE')

export const CATALOGUE_META_DETAIL_REQUEST =  type('CATALOGUE_META_DETAIL_REQUEST')
export const CATALOGUE_META_DETAIL_ENSURE =  type('CATALOGUE_META_DETAIL_ENSURE')

export const CATALOGUE_META_SAVE_REQUEST =  type('CATALOGUE_META_SAVE_REQUEST')
export const CATALOGUE_META_RESET_STATUS =  type('CATALOGUE_META_RESET_STATUS')

export const CATALOGUE_META_DELETE_REQUEST =  type('CATALOGUE_META_DELETE_REQUEST')

//////////////////////////////////////////////////////////////////
// FLUXBUILDER
/////////////////////////////////////////////////////////////////
export const CATALOGUE_FLUXBUILDER_REQUEST =  type('CATALOGUE_FLUXBUILDER_REQUEST')
export const CATALOGUE_FLUXBUILDER_ENSURE =  type('CATALOGUE_FLUXBUILDER_ENSURE')

export const CATALOGUE_FLUXBUILDER_DETAIL_REQUEST =  type('CATALOGUE_FLUXBUILDER_DETAIL_REQUEST')
export const CATALOGUE_FLUXBUILDER_DETAIL_ENSURE =  type('CATALOGUE_FLUXBUILDER_DETAIL_ENSURE')

export const CATALOGUE_FLUXBUILDER_SAVE_REQUEST =  type('CATALOGUE_FLUXBUILDER_SAVE_REQUEST')
export const CATALOGUE_FLUXBUILDER_RESET_STATUS =  type('CATALOGUE_FLUXBUILDER_RESET_STATUS')

export const CATALOGUE_FLUXBUILDER_DELETE_REQUEST =  type('CATALOGUE_FLUXBUILDER_DELETE_REQUEST')

